import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { CostType } from '../../../store/entities/costTypes/costTypes.types';
import { APIManagerConfig } from '../apiManager';

const CostTypesServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getCostTypes: (): Promise<CostType[]> =>
      HTTPBase.get(`farm/${config.farmId}/additonalcosttypes`).then((res) => res.data),
    createCostType: (data: Partial<CostType>, formName: FormName): Promise<CostType[]> =>
      HTTPBase.post(`farm/${config.farmId}/additonalcosttypes`, data, { headers: { formName } }).then(
        (res) => res.data,
      ),
    updateCostType: (id: string, data: Partial<CostType>, formName: FormName): Promise<CostType[]> =>
      HTTPBase.patch(`farm/${config.farmId}/additonalcosttypes/${id}`, data, { headers: { formName } }).then(
        (res) => res.data,
      ),
    deleteCostType: (id: string, formName: FormName): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/additonalcosttypes/${id}`, { headers: { formName } }).then(
        (res) => res.data,
      ),
  };
};

export default CostTypesServiceFactory;
